module.exports = __webpack_public_path__ + "static/media/gb-nir.080d0567.svg";